import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const ComparativeChart = ({ data, title, dataKey1, dataKey2, label1, label2 }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="font-oranienbaum font-medium text-foreground mb-2">
            {payload?.[0]?.payload?.name}
          </p>
          {payload?.map((entry, index) => (
            <p key={index} className="text-sm" style={{ color: entry?.color }}>
              {entry?.name}: €{entry?.value?.toFixed(2)}
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-lg p-4 md:p-6 shadow-md border border-border">
      <h3 className="text-lg md:text-xl font-oranienbaum font-semibold text-foreground mb-4 md:mb-6">
        {title}
      </h3>
      <div className="w-full h-64 md:h-80" aria-label={title}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#3A3A3A" />
            <XAxis
              dataKey="name"
              stroke="#B5B5B5"
              style={{ fontSize: '12px', fontFamily: 'Oranienbaum, serif' }}
            />
            <YAxis
              stroke="#B5B5B5"
              style={{ fontSize: '12px', fontFamily: 'Oranienbaum, serif' }}
              tickFormatter={(value) => `€${value}`}
            />
            <Tooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ fontSize: '14px', fontFamily: 'Oranienbaum, serif' }}
              iconType="circle"
            />
            <Bar
              dataKey={dataKey1}
              fill="#3A7F6B"
              radius={[8, 8, 0, 0]}
              name={label1}
            />
            <Bar
              dataKey={dataKey2}
              fill="#C9A24D"
              radius={[8, 8, 0, 0]}
              name={label2}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default ComparativeChart;